<template>
    <div class="logos container">
        <div class="row" v-for="(iconRow,i) in iconRows" :key="i" :class="{'text-right': i % 2 === 1, 'text-left': i % 2 == 0}">
            <div class="col" v-for="(icon,j) in iconRow" :key="j" :class="iconClass(icon)"

            >
                <fa-icon :class="icon" @mouseover="current = icon" @mouseleave="current = null" :icon="icon" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        perRow: {type: Number, default: 4}
    },
    data() {
        return {
            current: null,
            icons: [
                'fab fa-typo3', 'fab fa-aws', 'fab fa-docker',
                'fab fa-css3', 'fab fa-git', 'fab fa-html5', 'fab fa-symfony',
                'fab fa-jedi-order', 'fab fa-js', 'fab fa-node', 'fab fa-php',
                'fab fa-sass', 'fab fa-stripe', 'fab fa-vuejs'
            ]
        }
    },
    computed: {
        iconRows() {
            const numberOfRows = Math.ceil(this.icons.length / this.perRow);
            const rows = Array(numberOfRows);

            this.icons.forEach((icon, iteration) => {
                let page = Math.floor(iteration / this.perRow);
                let newIcon = icon.split(' ');
                    newIcon[1] = newIcon[1].replace('fa-', '')

                if (!rows[page]) rows[page] = [];
                rows[page].push(newIcon);
            });
            return rows;
        }
    },
    methods: {
        iconClass(icon) {
            if (this.current === null)
                return '';

            return (this.current === icon ? 'active' : 'inactive');
        }
    }
}
</script>

<style lang="scss">
.logos {
    .row {
        //margin: 3rem auto;
        text-align: center;
    }

    /*
    &:hover {
        i {
            filter: blur(10px);
            transform: scale(.9);
        }
    }
    */

    .col {
        &.active svg {
            opacity: .9;
            transform: scale(1);
            filter: blur(0);
        }

        &.inactive svg {
            filter: blur(5px);
            transform: scale(.9);
        }
    }

    svg {
        font-size: 4rem;
        margin: 1rem;
        color: #343a40;
        opacity: .4;
        will-change: transform, opacity, filter;
        transition: opacity 250ms ease, transform 250ms ease, filter 250ms ease;
        transform: scale(1);
    }
}
</style>
